<template>
  <div class="full-width">
    <div
      layout="column"
      layout-align="start start"
      class="full-width pr2-pc pl2-pc mb20-pc pb1-pc mb2-mobile pr1-mobile pl1-mobile bg-white"
    >
      <div
        layout="row"
        layout-align="start center"
        class="title grey--text text-uppercase font-weight-medium mb2-pc mb1-mobile mt3-pc full-width"
      >{{$t('nav.the_circles')}}
        <v-btn
          @click="displayFilters = !displayFilters"
          icon
          class="hidden-md-and-up ml-1"
        ><i
            :class="['mdi', displayFilters ? 'mdi-filter-remove' : 'mdi-filter']"
            style="color: black"
          ></i></v-btn>
      </div>
      <div
        v-if="!$vuetify.breakpoint.smAndDown || displayFilters"
        layout="row"
        layout-wrap
        layout-align="start center"
        class="full-width"
      >
        <div
          layout="column"
          class="subheading mb2-pc mb1-mobile font-weight-bold"
          flex="100"
        >{{$t('circles.search')}}</div>
        <div
          layout="column"
          :flex="$vuetify.breakpoint. smAndDown ? 100 : 33"
        >
          <v-text-field
            solo
            :label="$t('filters.keywords')"
            :hint="$t('circles.circle_hint')"
            persistent-hint
            v-model="filters.keywords"
            @keyup.enter="fetch"
            class="mr5-pc width-100-mobile"
          ></v-text-field>
        </div>
        <span flex></span>
        <v-btn
          depressed
          color="secondary"
          @click="fetch"
          large
        >{{$t('filters.filter_btn')}}</v-btn>
        {{$t('_.or')}}
        <a
          href="#"
          class="ml-2 black--text"
          @click.prevent="resetFilters"
        >{{$t('filters.reinit')}}</a>
      </div>
    </div>
    <div
      v-if="loading"
      layout="row"
      class="bg-white full-width"
      style="height: 100%"
      layout-align="center center"
    >
      <v-progress-circular
        indeterminate
        color="secondary"
        size="64"
      ></v-progress-circular>
    </div>
    <div
      v-else
      class="full-width pl2-pc pr2-pc pt3-pc pb5-pc px1-mobile py1-mobile bg-white"
    >
      <div class="font-weight-bold full-width mb3-pc mb1-mobile subheading">
        {{$t('circles.list')}}
      </div>
      <div class="font-weight-bold full-width subheading">
        <span class="secondary--text">{{total}}</span>&nbsp;
        <span v-if="total > 1">
          <span class="text-lowercase">{{$t('nav.circles')}}</span>
          {{$t('filters.match_pl')}} {{$t('filters.criteria')}}
        </span>
        <span v-else>
          <span class="text-lowercase">{{$t('circles.circle')}}</span>
          {{$t('filters.match')}} {{$t('filters.criteria')}}
        </span>
      </div>
      <ul class="full-width list mt-3 pa-1">
        <li class="list-item mb-2 mb5-pc ml-survey-card">
          <div
            layout="column"
            layout-align="center center"
            class="list-content"
          >
            <p></p>
            <v-btn
              @click="$router.push({name: 'circles-edit', params: {id: 'new'}})"
              style="width: 120px; height: 120px"
              icon
              color="#E5F7F7"
            >
              <v-icon
                size="120"
                color="secondary"
              >mdi-plus</v-icon>
            </v-btn>
            <div class="title mt-2">
              {{$t('circles.create')}}
            </div>
            <div class="mt-4 px-2 text-xs-center caption">
              {{$t('circles.add_hint')}}
            </div>
            <p></p>
          </div>
        </li>
        <li
          @click="goToCircle(c)"
          v-for="c in circles"
          :key="c.id"
          class="list-item clickable width-100-mobile mb-2 mb5-pc ml-survey-card"
        >
          <div class="list-content">
            <div
              layout="row"
              layout-wrap
              layout-align="end start"
            >
              <v-icon
                v-if="c.is_private"
                :title="$t('circles.is_private')"
              >mdi-lock</v-icon>
            </div>
            <div class="px-2">
              <div class="title pa-1 mt-4">
                {{c.name}}
              </div>
              <div class="mt-3 pa-1">{{c.description}}</div>
            </div>
            <p></p>
            <p></p>
            <div
              layout="row"
              layout-align="start center"
              class="grey--text pa-1 mt-4"
            >
              <avatar
                v-if="isMEN(c.creator) && $store.state.men_logo"
                size="20"
                :image="$store.state.men_logo"
                :fullname="c.created_by"
                class="mr-1"
              ></avatar>
              <avatar
                v-else
                size="20"
                :image="getImageData(c.creator_id)"
                :fullname="c.created_by"
                class="mr-1"
              ></avatar>
              {{$t('circles.created_by')}}&nbsp;
              <span
                v-if="isCurrent(c)"
                class="text-lowercase"
              >
                {{$t('_.yourself')}}
              </span>
              <span v-else-if="isMEN(c.creator)">
                {{$t('_.the')}} MEN
              </span>
              <span v-else-if="!c.creator || c.creator.is_deleted">
                {{$t('users.inactive')}}
              </span>
              <span v-else>
                {{c.creator.firstname}} {{c.creator.lastname}}
              </span>
            </div>
          </div>
        </li>
      </ul>

      <div class="text-xs-center mt-5 full-width">
        <v-pagination
          v-model="filters.page"
          :length="pages"
          color="secondary"
          total-visible="5"
          @input="fetch"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Circles from '@/api/circles'
import I18nMixin from '@/mixins/i18n'
import Consts from '@/consts'
import ImageMixin from '@/mixins/image'
import Avatar from '@/components/shared/Avatar.vue'
import Auth from '@/plugins/auth'

export default {
  mixins: [I18nMixin, ImageMixin],
  components: { Avatar },
  data () {
    return {
      filters: {
        keywords: null,
        rowsPerPage: 8,
        descending: 1,
        sortBy: 'created_at',
        page: 1
      },
      circles: [],
      displayFilters: false,
      total: 0,
      imgs: {},
      imgsLoad: {},
      loading: false
    }
  },
  mounted () {
    this.$store.commit('LOAD_LOGO')
    this.fetch()
  },
  methods: {
    goToCircle (c) {
      if (!c.is_private || c.creator_id === Auth.user.id) {
        this.$router.push({ name: 'circles-show', params: { id: c.id } })
      }
      for (let i = 0; i < c.users.length; i++) {
        if (c.users[i].id === Auth.user.id) {
          this.$router.push({ name: 'circles-show', params: { id: c.id } })
          break
        }
      }
    },
    fetch () {
      this.loading = true
      Circles.getList(this.filters).then(res => {
        this.circles = res.data.items
        this.total = res.data.total
        this.loading = false
        this.imgs = {}
        this.imgsLoad = {}

        for (let i = 0; i < this.circles.length; i++) {
          if (this.circles[i].creator && this.circles[i].creator.avatar_id) {
            this.getImage('/assets/users/' + this.circles[i].creator_id, this.circles[i].creator_id)
          }
        }
      })
    },
    resetFilters () {
      this.filters = {
        keywords: null,
        rowsPerPage: 8,
        descending: 1,
        sortBy: 'created_at',
        page: 1
      }
      this.fetch()
    },
    isMEN (c) {
      if (c && (c.is_admin || c.level == Consts.MINISTRY)) {
        return true
      }
      return false
    },
    isCurrent (s) {
      if (Auth.user.id == s.creator_id) {
        return true
      }
      return false
    },
  },
  computed: {
    pages () {
      return Math.ceil(this.total / this.filters.rowsPerPage)
    },
  }
}
</script>
<style scoped>
.survey-card {
  border: 1px solid lightgrey;
  /*height: -webkit-fill-available;*/
}
.list {
  display: flex;
  flex-wrap: wrap;
}
@media screen and (min-width: 960px) {
  .list-item {
    width: 31%;
  }
  .ml-survey-card {
    margin-left: 1.75%;
  }
}
@media screen and (max-width: 960px) {
  .list-item {
    width: 100%;
  }
}

.list-item {
  display: flex;
  border: 1px solid lightgrey;
}
.list-content {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  width: 100%;
}
.list-content p {
  flex: 1 0 auto;
}
</style>